export default {
  SOMETHING_WENT_WRONG: 'Something went wrong',
  WERE_SORRY: 'We\'re sorry, there was a temporary system error.',
  WERE_SORRY_WITH_NUMBER: 'We\'re sorry, there was a temporary system error. If you continue to experience this problem, please ',
  RETURN_TO_NETBENEFITS: 'Return to NetBenefits<sup>®</sup>',
  CHAT_WITH_REP: 'chat online with a representative.',
  NETBENEFITS_URL: 'https://nb.fidelity.com/netbenefits/navstation/navigation/mybenefitsww/stockplans/navigation/PlanSummary?',
  CHAT_URL: 'https://chat.fidelity.com/ftgw/chat/guest/login_page?refUrl=https://accountopening.fidelity.com/ftgw/aong/aongapp/accountSelectorEntry',
  MODAL_HEADER: 'Can we help you with your application?',
  MODAL_BODY1: 'A representative can walk you through the process and answer any questions you might have.',
  MODAL_BODY2: 'Contact a fidelity representative at 800-343-3548.',
  MODAL_FOOTER: 'Continue your application',
  OVERVIEW_URL: 'https://www.fidelity.com/open-account/overview',
  OVERLAY_EXIT_URL_LINK: 'https://www.fidelity.com/open-account/all-accounts',
  OVERLAY_EXIT_LINK_VAL: 'Exit your application',
  EXIT: 'Exit',
  START_NEW_APPLICATION: 'Start a new application',
  QUESTIONS_LINK: 'Questions?',
  QUESTIONS_MODAL_HEADER: 'Questions?',
  QUESTIONS_MODAL_BODY1: '800-343-3548',
  QUESTIONS_CHAT_WITH_REP: 'Chat with a representative',
  CUSTOMER_IGO_PAGE_HEADER: 'Your username and password are established',
  WELCOME_BACK_PAGE_HEADER: 'Welcome back',
  ISTOCK_REGTYPE: 'iStock',
  ROLLOVERIRA_REGTYPE: 'rolloverIRA',
  BACK_BUTTON_WARNING: 'To navigate, please use the buttons or links provided on the page.',
  SESSION_TIMEOUT_PAGE_HEADER: 'Your session has timed out',
  SESSION_TIMEOUT_TEXT: 'For your security, your account opening session has timed out.',
  FLOW_TYPES: {
    EXPRESS: 'Express',
    LONG: 'Long',
    EXCEPTION: 'Exception',
  },
  SECONDARYFIRSTNAME: 'SECONDARYFIRSTNAME',
  PRIMARYFULLNAME: 'PRIMARYFULLNAME',
  SECONDARYFULLNAME: 'SECONDARYFULLNAME',
  YOUTH_PARENT_AGREEMENT: 'youthParentAgreement',
  YOUTH_CHILD_AGREEMENT: 'youthChildAgreement',
  YOUTH_TAX_AGREEMENT: 'youthTaxAgreement',
};
